import { render, staticRenderFns } from "./QuotingCard.vue?vue&type=template&id=56bcb145&scoped=true"
import script from "./QuotingCard.vue?vue&type=script&lang=js"
export * from "./QuotingCard.vue?vue&type=script&lang=js"
import style0 from "./QuotingCard.vue?vue&type=style&index=0&id=56bcb145&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bcb145",
  null
  
)

export default component.exports